import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import {
  authReducer,
  dataReducer,
  organizationsReducer,
  associationDashboardStateReducer,
  generalAssociationDashboardReducer,
  languageReducer,
  currentNavPageReducer,
  sourcesTokensReducer,
  visibleSearchLayerReducer,
  appIsEmbeddedReducer,
  subMenuDirectionReducer,
  subMenuDirectionToggleReducer,
  balanceReducer,
  balanceSheetReducer,
  indicatorsReducer,
  dashboardReducer,
  dashboardCompositionReducer,
  dashboardListReducer,
  slideCompositionReducer,
  slideListReducer,
  authorizationsReducer,
  authorizationsSettingsReducer,
  annexeListReducer,
  annexeCategorySuggestionsReducer,
  annexeCategoriesReducer,
  balanceSheetAttachmentsReducer,
  presentationReducer,
  accessKeyReducer,
  PreparePresentationReducer,
  indicatorsExplanationReducer,
  extraSlideListReducer,
  collaboratorReducer,
  fiduciaryReducer,
  backOfficeReducer
} from "Reducers";

export const createReducer = () =>
  combineReducers({
    auth: authReducer,
    financialProfile: dataReducer,
    params: combineReducers({
      lng: languageReducer,
      currentNavPage: currentNavPageReducer,
      sourcesTokens: sourcesTokensReducer,
      visibleSearchLayer: visibleSearchLayerReducer,
      embedded: appIsEmbeddedReducer,
      subMenuDirection: subMenuDirectionReducer,
      subMenuDirectionToggle: subMenuDirectionToggleReducer,
      backOffice: backOfficeReducer
    }),
    routing: routerReducer,
    organizations: combineReducers({
      list: organizationsReducer,
      selected: [],
      associationDashboard: associationDashboardStateReducer,
      association: generalAssociationDashboardReducer
    }),
    balance: balanceReducer,
    balanceSheet: balanceSheetReducer,
    indicators: indicatorsReducer,
    dashboard: dashboardReducer,
    dashboardComposition: dashboardCompositionReducer,
    slideList: slideListReducer,
    dashboardList: dashboardListReducer,
    slideComposition: slideCompositionReducer,
    authorizations: authorizationsReducer,
    authorizationsSettings: authorizationsSettingsReducer,
    annexes: combineReducers({
      annexesList: annexeListReducer,
      balanceSheetAttachments: balanceSheetAttachmentsReducer
    }),
    annexeCategorySuggestions: annexeCategorySuggestionsReducer,
    annexeCategories: annexeCategoriesReducer,
    presentation: presentationReducer,
    accessKey: accessKeyReducer,
    preparePresentation: PreparePresentationReducer,
    indicatorsExplanation: indicatorsExplanationReducer,
    extraSlideList: extraSlideListReducer,
    collaboratorList: collaboratorReducer,
    fiduciary: fiduciaryReducer
  });



// WEBPACK FOOTER //
// ./src/store/createReducer.js